import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Deep-link redirect for /order-management/quotes/:quoteId.
 *
 * The standalone QuoteDetailPage is retired in favor of the search-results +
 * editor-drawer flow (mirrors the PRO search UX): a quote URL now lands on
 * /searchresults with the quote pre-opened in the lane editor drawer. The `q`
 * param (the quote number) drives the visible result list; `quote` (number-rev)
 * opens the drawer. SearchResults builds the drawer lane straight from `quote`,
 * so the drawer opens even before the result list finishes loading.
 *
 * A "Q-" prefix is tolerated (QuoteDetailPage accepted it too); the digits
 * before the dash drive the search, the full id opens the drawer.
 */
const QuoteDeepLinkRedirect: React.FC = () => {
  const { quoteId = '' } = useParams<{ quoteId: string }>();
  const id = quoteId.replace(/^Q-/i, '');
  const number = id.split('-')[0];
  return (
    <Navigate
      to={`/searchresults?q=${encodeURIComponent(number)}&quote=${encodeURIComponent(id)}`}
      replace
    />
  );
};

export default QuoteDeepLinkRedirect;
